import { useQuery } from "@tanstack/react-query";
import { priorityService } from "@/services/priorityService";
import { teamApi } from "@/services/teamService";
import { userService } from "@/services/userService";

type ListParams = Parameters<typeof priorityService.getPriorities>[0];

/** Every query /priorities needs, so the page itself talks to hooks only. */
export function usePriorityPageData(params: ListParams, userSearch: string) {
  // Server default sort is PPP rank → created_at; no client sort, no drag.
  const list = useQuery({
    queryKey: ["priorities", "list", params],
    queryFn: () => priorityService.getPriorities(params),
  });
  const overview = useQuery({
    queryKey: ["priorities", "overview"],
    queryFn: () => priorityService.getOverview(),
  });
  const users = useQuery({
    queryKey: ["users", userSearch],
    queryFn: () => userService.getCompanyUsers(userSearch),
  });
  const teams = useQuery({ queryKey: ["teams"], queryFn: () => teamApi.getAll() });

  return {
    priorities: list.data?.data ?? [],
    total: list.data?.total ?? 0,
    isLoading: list.isLoading,
    isError: list.isError,
    overview: overview.data,
    users: users.data?.data ?? [],
    teams: teams.data?.data ?? [],
  };
}
